import { Flex, Loading, Text } from 'ui'
import { toTitleCase } from 'lib/string'
import { useEditMemberContext } from '../context/EditMemberProvider'
import { RemoveCompanyButton } from './RemoveCompanyButton'

export const EditSingleCompanyMemberForm = () => {
  const {
    state: { member },
  } = useEditMemberContext()

  if (!member) {
    return <Loading />
  }

  return (
    <Flex flexDirection="column" gap={3}>
      <Flex flexDirection="column" gap={1}>
        <Text>{toTitleCase(member.name)}</Text>
        <Text color="lightText">{member.email}</Text>
        <Text color="lightText">
          Role: {member.companyRolePermission?.description}
        </Text>
      </Flex>
      <Flex flexDirection="row" justifyContent="flex-end" gap={2}>
        <RemoveCompanyButton
          company={member.companies[0]}
          label="Remove access"
        />
      </Flex>
    </Flex>
  )
}
